<template>
    <div class="animatedParent animateOnce go" data-sequence="500">
      <app-header class="haeder-r"></app-header>
        <!--slider end -->
        <div class="box-title animatedParent animateOnce" data-sequence="500">
            <h2 class="animated bounceInUp go" v-lang.about></h2>
        </div>
        <section class="about-page">
            <div class="container">
                <div class="row first-row  animatedParent animateOnce go"  >
                    <div class="col-md-12  animated bounceInUp go"  >
                          <p>
                          </p>
                    </div>
                </div>
              <!--***************************************-->
                <div class="row second-row animated bounceInLeft go"  >
                    <div class="col-md-6 col-xs-12 col-sm-12">
                        <div class="col-md-2 col-sm-4 col-xs-12 text-center">
                            <img src="/static/img/mission.png" alt="">
                        </div>
                        <div class="col-md-10 col-sm-8 col-xs-12">
                            <h4 v-lang.outgoals></h4>
                            <p v-lang.goalsdesc>
                            </p>
                        </div>
                        <!--***************************************-->
                        <div class="col-md-2 col-sm-4 col-xs-12 text-center">
                          <img src="/static/img/idea.png" alt="">
                        </div>
                        <div class="col-md-10 col-sm-8 col-xs-12">
                          <h4 v-lang.ourmessage></h4>
                          <p v-lang.messagedesc>
                          </p>
                        </div>
                    </div>
                        <!--***************************************-->
                    <div class="animated bounceInLeft go">
                      <div class="col-md-6">
                        <div class="col-md-2 col-sm-4 col-xs-12 text-center">
                          <img src="/static/img/vision_icon.png" alt="">
                        </div>
                        <div class="col-md-10 col-sm-8 col-xs-12">
                          <h4 v-lang.ourvesion></h4>
                          <p v-lang.vesiondesc>
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="col-md-2 col-sm-4 col-xs-12 text-center">
                          <img src="/static/img/hands_icon.png" alt="">
                        </div>
                        <div class="col-md-10 col-sm-8 col-xs-12">
                          <h4 v-lang.outvalues></h4>
                          <p v-lang.valuesdesc>
                          </p>
                        </div>
                      </div>
                    </div>
                </div>
            </div>

        </section>
        <div class="container">
          <div class="row">
            <div class="our-team">
              <div class="box-title animatedParent animateOnce" data-sequence="500">
                <h2 class="animated bounceInUp go" v-lang.team></h2>
              </div>
              <ul>
            
              <li class="col-md-4 col-sm-6 col-xs-12 col-lg-6">
                  <div class="img-team" style="background-image:url('https://core.archotek.com/uploads/gallery/1/9RTykQIaoZInTX3AvmdUG2yFDtqNup7gEZBunYgF.jpeg')"></div>
                  <h2 v-lang.aktaa></h2>
                  <h5 v-lang.memareng> </h5>
              </li>

              

                <li class="col-md-4 col-sm-6 col-xs-12 col-lg-6" >
                  <div class="img-team" style="background-image:url('https://core.archotek.com/uploads/gallery/1/0dRg3KXvZRG3Ca7nyLIki8qOxeg0spexNBZfk1VN.jpeg')"></div>
                  <h2 v-lang.babii></h2>
                  <h5 v-lang.salesmanager></h5>
                </li>
              </ul>
            </div>
          </div>
        </div>
      <app-footer></app-footer>
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        mounted() {
            $(document).ready(function () {
                $(".menu-btn a").click(function () {
                    $(".overlay").fadeToggle(100);
                    $(this).toggleClass('btn-open').toggleClass('btn-close');
                });
                $(".overlay").click(function () {
                    $(".btn-close").click();
                });

                $('.menu a').on('click', function () {
                    $(".overlay").fadeToggle(100);
                    $(".menu-btn a").toggleClass('btn-open').toggleClass('btn-close');
                });
            });
            $('.carousel').carousel();
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/about.vue